import { Grid } from '@mui/material';
import TestIds from 'Tests/TestIds';
import useTranslate from "../../../../../../Hooks/useTranslate";
import { useStyles } from "../Directories.styles";
import DirectoryExtraInfo from './DirectoryExtraInfo';

interface Props {
    directory: IDirectoryAuthenticatingPersonType;
    index: number;
}

function DirectoryExtraInfoBlock(props: Readonly<Props>) {
    const { directory, index } = props;
    const ts = useTranslate();
    const classes = useStyles();

    const { identifier, identityIdentifier } = directory;
    const hasIdentifier = !!identifier;
    const hasIdentityIdentifier = !!identityIdentifier;

    return (
        <Grid
            item
            xs={12}
            sm={9}
            sx={{ minWidth: 0 }}
            className={directory.isRoutable ? classes.directoryExtraInfoBloc : undefined}
            data-testid={
                TestIds.pages.userProfile.directories.directoryExtraInfoBloc +
                '-' +
                identityIdentifier
            }
        >
            {hasIdentifier && (
                <DirectoryExtraInfo
                    key={directory.label + 'directory.identifier'}
                    title={ts('page.userProfile.section.technical.identifier')}
                    content={identifier}
                    id={
                        TestIds.pages.userProfile.directories.identifier +
                        '-' +
                        index
                    }
                />
            )}
            {hasIdentityIdentifier && (
              <DirectoryExtraInfo
                  key={directory.label + 'directory.identityIdentifier'}
                  title={ts('page.userProfile.section.technical.identityIdentifier')}
                  content={identityIdentifier}
                  id={
                      TestIds.pages.userProfile.directories.identityIdentifier +
                      '-' +
                      index
                  }
              />
            )}
            {!!directory.customAttribute?.tenantId && (
                <DirectoryExtraInfo
                    key={directory.label + 'directory.customAttribute.tenantId'}
                    id={
                        TestIds.pages.userProfile.directories.tenantid +
                        '-' +
                        index
                    }
                    title={ts('page.userProfile.section.technical.tenantId')}
                    content={directory.customAttribute.tenantId}
                />
            )}
            {!!directory.customAttribute?.objectId && (
                <DirectoryExtraInfo
                    key={directory.label + 'directory.customAttribute.objectId'}
                    id={
                        TestIds.pages.userProfile.directories.objectId +
                        '-' +
                        index
                    }
                    title={ts('page.userProfile.section.technical.objectId')}
                    content={directory.customAttribute.objectId}
                />
            )}
            {!!directory.customAttribute?.upn && (
                <DirectoryExtraInfo
                    key={directory.label + 'directory.customAttribute.upn'}
                    id={
                        TestIds.pages.userProfile.directories.upn + '-' + index
                    }
                    title={ts('page.userProfile.section.technical.upn')}
                    content={directory.customAttribute.upn}
                />
            )}
        </Grid>
    )
}

export default DirectoryExtraInfoBlock;
